<script>
import { useStore } from 'vuex';

import Header from '../src/components/Header.vue'
import SideMenu from '../src/components/SideMenu.vue'
import Snackbar from './components/Snackbar.vue';
import Iframe from './views/Iframe.vue';
// import VideoStream from './views/Layouts/VideoStream.vue';
import LayoutsPage from './views/Layouts/LayoutsPage.vue';
import DownloadProgress from './components/DownloadProgress.vue';

import { validateToken } from './js/tokenValidator';

export default {
  components: {
    Header,
    SideMenu,
    Snackbar,
    Iframe,
    // VideoStream,
    LayoutsPage,
    DownloadProgress,
  },
  directives: {
    iframeResize: {
      mounted: (el, binding) => {
        binding.instance.sendHeight = () => {
          let height = document.querySelector('.layout-wrapper')?.scrollHeight ?? 0;
          height += 5; // Add a small buffer to ensure the iframe resizes correctly
          window.parent.postMessage({ height }, "*");
        }

        binding.instance.$nextTick(() => {
          binding.instance.sendHeight();
        });
        
        // Use a more comprehensive mutation observer
        if (typeof ResizeObserver !== 'undefined') {
          const resizeObserver = new ResizeObserver(binding.instance.sendHeight);
          resizeObserver.observe(document.body);
          binding.instance.resizeObserver = resizeObserver;
        }

        const mutationObserver = new MutationObserver(binding.instance.sendHeight);
        mutationObserver.observe(document.body, { 
          childList: true, 
          subtree: true, 
          attributes: true,
          characterData: true 
        });
        
        // Add multiple event listeners for various scenarios that could affect layout
        window.addEventListener("resize", binding.instance.sendHeight);
        window.addEventListener("load", binding.instance.sendHeight);
        window.addEventListener("transitionend", binding.instance.sendHeight);
        window.addEventListener("animationend", binding.instance.sendHeight);
        
        // Set up a regular polling interval as a fallback
        binding.instance.heightInterval = setInterval(binding.instance.sendHeight, 1000);
        
        binding.instance.mutationObserver = mutationObserver;

        window.addEventListener('focus', () => validateToken);
      },
      beforeUnmounted: (el, binding) => {
        // Clean up all event listeners and timers
        window.removeEventListener("resize", binding.instance.sendHeight);
        window.removeEventListener("load", binding.instance.sendHeight);
        window.removeEventListener("transitionend", binding.instance.sendHeight);
        window.removeEventListener("animationend", binding.instance.sendHeight);
        
        if (binding.instance.heightInterval) {
          clearInterval(binding.instance.heightInterval);
        }
        
        if (binding.instance.mutationObserver) {
          binding.instance.mutationObserver.disconnect();
          binding.instance.mutationObserver = null;
        }
        if (binding.instance.resizeObserver) {
          binding.instance.resizeObserver.disconnect();
          binding.instance.resizeObserver = null;
        }
      }
    }
  },
  setup() {
    const store = useStore();

    return {
      store,
    }
  },
  data() {
    return {
      loadOnAuth: false,
    }
  },
  computed: {
    user() {
      return this.store.state.user;
    },
    isAuthenticated() {
      return this.store.state.isAuthenticated;
    },
    isEmbed() {
      return !!this.$route.name.toLowerCase().includes('embed');
    },
    layout() {
      return this.$route.meta.layout;
    },
    isIframe() {
      return this.$route.meta.isIframe;
    },
    iframeName() {
      return this.$route.meta.iframeName;
    },
    isStream() {
      return this.$route.meta.isStream;
    }
  },
  async beforeMount() {
    if (this.isAuthenticated && !this.store.state.user) {
      await this.store.dispatch('fetchUser');
    }
  },
}
</script>

<template>
  <div>
    <metainfo>
      <template v-slot:title="{ content }">{{ content }} | Vlife</template>
    </metainfo>
  </div>

  <DownloadProgress />

  <template v-if="!isStream">
    <template v-if="isIframe" v-iframe-resize>
      <Iframe v-bind:iframeName="iframeName" />
    </template>
    <Snackbar v-if="!layout && !isIframe" />
    <div v-if="user && isAuthenticated && !layout && !isIframe" class="logged-state">
      <Header></Header>
      <div class="page-content">
        <SideMenu></SideMenu>

        <div class="content">
          <RouterView />
        </div>

        <img id="vlife-frame" src="@/assets/media/vlife-frame.png" alt="frame">
      </div>
    </div>
    <template v-else>
      <RouterView v-if="(!isAuthenticated && !user) || layout" v-iframe-resize />
    </template>
  </template>

  <template v-if="isStream">
    <!-- <VideoStream /> -->
    <LayoutsPage v-iframe-resize />
  </template>

</template>

<style scoped>
.logged-state {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  max-height: 100vh;
}

.page-content {
  width: 100%;
  flex: 1;
  display: flex;
  overflow: hidden;
  margin-top: -65px;
}

.page-content .content {
  flex: 1;
  /* max-height: calc(100vh - 4rem); */
  /* height: calc(100vh - (var(--header-height) + 65px)); */
  /* height: 100svh; */
  max-height: calc(100vh);
  width: 100%;
  padding: 2rem;
  overflow-y: auto;
  z-index: 1;
  margin-top: 65px;
}

#vlife-frame {
  position: absolute;
  /* width: calc(100% - var(--side-menu-width)); */
  /* height: calc(100vh * 1.2); */
  height: 100svh;
  /* right: 0; */
  right: -90px;
  top: -40px;
  opacity: 0.2;
  pointer-events: none;
}

@media only screen and (max-width: 900px) {
  #vlife-frame {
    /* width: 100%; */
    right: -40px;

  }
}

@media only screen and (max-width: 900px) {
  .page-content .content {
    padding: 1rem;
  }
}
</style>
